import type { PayerErrorLike } from './PayerErrorMessage';

export const toPayerErrorLike = (error: unknown): PayerErrorLike => {
  if (typeof error === 'object' && error !== null) {
    const maybeAny = error as any;
    return {
      code: typeof maybeAny.code === 'string' ? maybeAny.code : undefined,
      message: typeof maybeAny.message === 'string' ? maybeAny.message : undefined,
      stack: typeof maybeAny.stack === 'string' ? maybeAny.stack : undefined,
    };
  }

  if (typeof error === 'string') return { message: error };

  return { message: 'Unknown error' };
};
